import { Injectable } from '@angular/core';
import { Statistics } from '@models/statistics.interface';

@Injectable({
    providedIn: 'root'
})
export class WriterStatisticsService {
    constructor() { }

    public get getWriterStatistics(): Statistics {
        return this.writerTitlesIcons();
    }
    private writerTitlesIcons(): Statistics {
        const writerTitleAndIcons = [
          {
            key: 'questions_submitted',
            title: 'Questions Submitted',
            icon: 'question_check'
          },
          {
            key: 'questions_published',
            title: 'Questions Accepted',
            icon: 'circle_check_mark'
          },
          {
            key: 'questions_rejected',
            title: 'Questions Rejected',
            icon: 'question_rejected'
          },
          {
            key: 'questions_needs_review',
            title: 'Questions in Factchecking Queue',
            icon: 'question_que'
          }
        ];
        return writerTitleAndIcons;
      }

}
